var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "header-search" },
    [
      _c("a-icon", {
        staticClass: "search-icon",
        attrs: { type: "search" },
        on: { click: _vm.enterSearchMode }
      }),
      _vm._v(" "),
      _c("a-auto-complete", {
        ref: "input",
        class: ["search-input", _vm.searchMode ? "enter" : "leave"],
        attrs: { dataSource: _vm.dataSource, placeholder: "站内搜索" },
        on: { blur: _vm.leaveSearchMode }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-166a4254", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-166a4254","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/HeaderSearch.vue
// module id = null
// module chunks = 